"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Mobiledoc_1 = require("../types/Mobiledoc");
var utils_1 = require("../utils");
var isValidElement = utils_1.includedIn(utils_1.objectValues(__assign(__assign(__assign(__assign(__assign({}, Mobiledoc_1.MarkupSectionTagName), Mobiledoc_1.ImageSectionTagName), Mobiledoc_1.ListSectionTagName), Mobiledoc_1.ListItemTagName), Mobiledoc_1.MarkupTagName)));
var getMarkupComponentDefault = function (tagName) {
    return isValidElement(tagName)
        ? tagName
        : utils_1.throwError("`" + tagName + "` is not a supported Mobiledoc tag.");
};
exports.default = getMarkupComponentDefault;
